export default __webpack_public_path__ + "static/media/yellow_1.png";